import { render, staticRenderFns } from "./UpdateMatchSettingDialog.vue?vue&type=template&id=58ae6dfa"
import script from "./UpdateMatchSettingDialog.vue?vue&type=script&lang=js"
export * from "./UpdateMatchSettingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports